import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
import * as LayoutEvents from "../../../lib/LayoutEvents";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles, globalClasses } from "../ScrollContainer.styles";
import { scrollSizeParametersNames } from "../ScrollContainer.constants";
import { getScrollYOffset, convertScrollbarXScrollState, convertScrollbarYScrollState } from "../ScrollContainer.helpers";
import { ScrollBar } from "../ScrollBar";
export var ScrollContainer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ScrollContainer, _React$Component);

  function ScrollContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.scrollX = void 0;
    _this.scrollY = void 0;
    _this.inner = void 0;

    _this.render = function () {
      var props = _this.props;
      var innerStyle = {
        scrollBehavior: props.scrollBehaviour,
        maxHeight: props.maxHeight,
        maxWidth: props.maxWidth
      };

      var scrollbarY = _this.renderScrollbar('y');

      var scrollbarX = _this.renderScrollbar('x');

      return /*#__PURE__*/React.createElement(CommonWrapper, _this.props, /*#__PURE__*/React.createElement("div", {
        className: styles.root(),
        onMouseMove: _this.handleMouseMove,
        onMouseLeave: _this.handleMouseLeave
      }, scrollbarY, scrollbarX, /*#__PURE__*/React.createElement("div", {
        style: innerStyle,
        ref: _this.refInner,
        className: cx(styles.inner(), globalClasses.inner),
        "data-tid": "ScrollContainer__inner",
        onScroll: _this.handleNativeScroll
      }, props.children)));
    };

    _this.renderScrollbar = function (axis) {
      var refScrollBar = axis === 'x' ? _this.refScrollBarX : _this.refScrollBarY;
      return /*#__PURE__*/React.createElement(ScrollBar, {
        axis: axis,
        ref: refScrollBar,
        invert: _this.props.invert,
        onScrollStateChange: _this.handleScrollStateChange
      });
    };

    _this.handleScrollStateChange = function (scrollState, axis) {
      if (!_this.scrollY || !_this.scrollX) {
        return;
      }

      if (axis === 'x') {
        var scrollXState = convertScrollbarXScrollState(scrollState);
        _this.props.onScrollStateChangeX == null ? void 0 : _this.props.onScrollStateChangeX(scrollXState);
        return;
      }

      var scrollYState = convertScrollbarYScrollState(scrollState);
      _this.props.onScrollStateChange == null ? void 0 : _this.props.onScrollStateChange(scrollYState);
      _this.props.onScrollStateChangeY == null ? void 0 : _this.props.onScrollStateChangeY(scrollYState);
    };

    _this.refScrollBarY = function (scrollbar) {
      _this.scrollY = scrollbar;
    };

    _this.refScrollBarX = function (scrollbar) {
      _this.scrollX = scrollbar;
    };

    _this.refInner = function (element) {
      if (!_this.inner && element && _this.props.preventWindowScroll) {
        element.addEventListener('wheel', _this.handleInnerScrollWheel, {
          passive: false
        });
      }

      if (_this.inner && !element) {
        _this.inner.removeEventListener('wheel', _this.handleInnerScrollWheel);
      }

      _this.inner = element;
    };

    _this.handleNativeScroll = function (event) {
      var _this$scrollX, _this$scrollY;

      (_this$scrollX = _this.scrollX) == null ? void 0 : _this$scrollX.reflow();
      (_this$scrollY = _this.scrollY) == null ? void 0 : _this$scrollY.reflow();
      _this.props.onScroll == null ? void 0 : _this.props.onScroll(event);

      if (_this.props.preventWindowScroll) {
        event.preventDefault();
        return;
      }

      LayoutEvents.emit();
    };

    _this.handleInnerScrollWheel = function (event) {
      if (!_this.inner || !(event instanceof WheelEvent)) {
        return;
      }

      var axis = event.shiftKey ? 'x' : 'y';

      if (_this.hasScrollBar(axis)) {
        var _scrollSizeParameters = scrollSizeParametersNames[axis],
            pos = _scrollSizeParameters.pos,
            size = _scrollSizeParameters.size,
            offset = _scrollSizeParameters.offset;

        if (event.deltaY > 0 && _this.inner[size] <= _this.inner[pos] + _this.inner[offset]) {
          event.preventDefault();
          return false;
        }

        if (event.deltaY < 0 && _this.inner[pos] <= 0) {
          event.preventDefault();
          return false;
        }
      }
    };

    _this.handleMouseMove = function (event) {
      var _this$scrollY2, _this$scrollX2;

      var right = event.currentTarget.getBoundingClientRect().right - event.pageX;
      var bottom = event.currentTarget.getBoundingClientRect().bottom - event.pageY;
      (_this$scrollY2 = _this.scrollY) == null ? void 0 : _this$scrollY2.setHover(right <= 12);
      (_this$scrollX2 = _this.scrollX) == null ? void 0 : _this$scrollX2.setHover(right >= 12 && bottom <= 12);
    };

    _this.handleMouseLeave = function () {
      var _this$scrollY3, _this$scrollX3;

      (_this$scrollY3 = _this.scrollY) == null ? void 0 : _this$scrollY3.setHover(false);
      (_this$scrollX3 = _this.scrollX) == null ? void 0 : _this$scrollX3.setHover(false);
    };

    return _this;
  }

  var _proto = ScrollContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$scrollX4, _this$scrollY4;

    (_this$scrollX4 = this.scrollX) == null ? void 0 : _this$scrollX4.setInnerElement(this.inner);
    (_this$scrollY4 = this.scrollY) == null ? void 0 : _this$scrollY4.setInnerElement(this.inner);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.inner) {
      if (prevProps.preventWindowScroll && !this.props.preventWindowScroll) {
        this.inner.removeEventListener('wheel', this.handleInnerScrollWheel);
      }

      if (!prevProps.preventWindowScroll && this.props.preventWindowScroll) {
        this.inner.addEventListener('wheel', this.handleInnerScrollWheel, {
          passive: false
        });
      }
    }
  };
  /**
  * @public
  * @param {HTMLElement} element
  */


  _proto.scrollTo = function scrollTo(element) {
    if (!element || !this.inner) {
      return;
    }

    this.inner.scrollLeft = element.offsetLeft;
    this.inner.scrollTop = getScrollYOffset(element, this.inner);
  }
  /**
  * @public
  */
  ;

  _proto.scrollToTop = function scrollToTop() {
    if (!this.inner) {
      return;
    }

    this.inner.scrollTop = 0;
  }
  /**
  * @public
  */
  ;

  _proto.scrollToBottom = function scrollToBottom() {
    if (!this.inner) {
      return;
    }

    this.inner.scrollTop = this.inner.scrollHeight - this.inner.offsetHeight;
  }
  /**
  * @public
  */
  ;

  _proto.scrollToLeft = function scrollToLeft() {
    if (!this.inner) {
      return;
    }

    this.inner.scrollLeft = 0;
  }
  /**
  * @public
  */
  ;

  _proto.scrollToRight = function scrollToRight() {
    if (!this.inner) {
      return;
    }

    this.inner.scrollLeft = this.inner.scrollWidth - this.inner.offsetWidth;
  };

  _proto.hasScrollBar = function hasScrollBar(axis) {
    if (!this.inner) {
      return false;
    }

    return axis === 'x' ? this.inner.offsetWidth < this.inner.scrollWidth : this.inner.offsetHeight < this.inner.scrollHeight;
  };

  return ScrollContainer;
}(React.Component);
ScrollContainer.__KONTUR_REACT_UI__ = 'ScrollContainer';
ScrollContainer.propTypes = {
  invert: PropTypes.bool,
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  scrollBehaviour: PropTypes.oneOf(['auto', 'smooth']),
  preventWindowScroll: PropTypes.bool,
  onScrollStateChange: PropTypes.func
};
ScrollContainer.defaultProps = {
  invert: false,
  scrollBehaviour: 'auto',
  preventWindowScroll: false
};